
import React, { Component } from 'react';
import './Education.css';

class Education extends Component {
  render() {
    return (
      <div className="card border-dark mb-3">
        <div className="card-header" style={{ backgroundColor: "#cdff22" }}>
          <h2><span className="fa fa-file-text-o fa-lg"></span>Educations</h2>
        </div>
        <div className="card-body" style={{ paddingBottom: "0" }}>
          <h5 className="card-title" style={{ marginLeft: "26px" }}>Bone to be Electronics and Computer Engineer. I'm still learning!, not for any degrees or certificates, but the KNOWNLEDGE!</h5>
          <table className="table table-sm">
            <tbody>
              <tr className="">
                <td><span className="fa fa-file-text-o fa-sm"></span><b>Post-Doctoral. </b> National Electronics and Computer Technology Center (NECTEC), National Science and Technology Development Agency (NSTDA), 2012-2013</td>
              </tr>
              <tr className="">
                <td><span className="fa fa-file-text-o fa-sm"></span><b>Ph.D. </b> Electrical and Computer Engineering (International Program), KMUTT, 2009-2012</td>
              </tr>
              <tr className="">
                <td><span className="fa fa-file-text-o fa-sm"></span><b>M.Eng. </b> Electrical Engineering (Control System and Instrumentation Engineering), KMUTT, 2008-2009</td>
              </tr>
              <tr className="">
                <td><span className="fa fa-file-text-o fa-sm"></span><b>B.Eng. </b> Control System and Instrumentation Engineering, KMUTT, 2006-2008 </td>
              </tr>
              <tr className="">
                <td><span className="fa fa-file-text-o fa-sm"></span><b>Dep.Voc.Cert. </b> Electronics, Suratthani Technical College , 2003-2005 </td>
              </tr>
              <tr className="">
                <td><span className="fa fa-file-text-o fa-sm"></span><b>Voc.Cert. </b> Electronics, Suratthani Technical College , 2000-2003 </td>
              </tr>
              </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default Education;

